import React from "react";
import { useTranslation } from 'react-i18next';
import "./styles.css";

const CustomModal = ({
  open,
  onCancel,
  onOk,
  title,
  children,
  okText = "OK",
  cancelText,
  footer = undefined,
  loading = false,
  width = "520px",
  contentClassName = ""
}) => {
  const { t } = useTranslation('common');
  const resolvedCancelText = cancelText ?? t('buttons.cancel');
  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel?.();
    }
  };

  const handleOk = () => {
    if (!loading) {
      onOk?.();
    }
  };

  const renderFooter = () => {
    if (footer === null) return null;
    
    if (footer) return footer;

    return (
      <div className="custom-modal-footer">
        <button
          className="custom-modal-button custom-modal-button-cancel"
          onClick={onCancel}
          disabled={loading}
          type="button"
        >
          {resolvedCancelText}
        </button>
        <button
          className="custom-modal-button custom-modal-button-ok"
          onClick={handleOk}
          disabled={loading}
          type="button"
        >
          {loading ? t('buttons.loading') : okText}
        </button>
      </div>
    );
  };

  return (
    <div className="custom-modal-backdrop" onClick={handleBackdropClick}>
      <div 
        className="custom-modal-container" 
        style={{ width }}
        role="dialog" 
        aria-labelledby="custom-modal-title"
      >
        {title && (
          <div className="custom-modal-header">
            <h2 id="custom-modal-title" className="custom-modal-title">
              {title}
            </h2>
          </div>
        )}
        
        <div className={`custom-modal-content ${contentClassName}`}>
          {children}
        </div>
        
        {renderFooter()}
      </div>
    </div>
  );
};

export default CustomModal;
